import * as React from "react"
const Windows = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M2.165 2.385h4.802v4.802H2.165V2.385Zm6.003 0h4.802v4.802H8.168V2.385ZM2.165 8.388h4.802v4.801H2.165V8.388Zm6.003 0h4.802v4.801H8.168V8.388Z"
    />
  </svg>
)
export default Windows